/** shared menu in company settings */
export const isSharedMenu = (companyId: string = '', locationId: string = '') => companyId !== '' && locationId === '';

export const isSharedMenuAssignedToCurrentLocation = (parentTemplateId?: string) => !!parentTemplateId;
